// extracted by mini-css-extract-plugin
export default {"file-detail":"style_file-detail__bRHc-"};